import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InputComponent } from "./input.component";
import { LocalizationCommonModule } from "src/app/core/lib/localization";

@NgModule({
  declarations: [InputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizationCommonModule,
  ],
  exports: [InputComponent],
})
export class InputModule {}
